import {Component, Injector, Input, OnInit} from "@angular/core";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {
    AbstractMultiSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-multi-select-edit-control.component";
import {OrderTypeInfoData} from "../order-type-info.data";

@Component({
    selector: "wbo-order-type-multi-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/multi-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(OrderTypeMultiSelectEditControlComponent)
    ]
})
export class OrderTypeMultiSelectEditControlComponent extends AbstractMultiSelectEditControlComponent<any> implements OnInit {
    @Input() appTypesOnly: boolean = false;

    constructor(injector: Injector) {
        super(undefined, injector, "orderType", "name");
    }

    override ngOnInit(): void {
        super.ngOnInit();
        if (this.appTypesOnly) {
            this.buildData([
                {
                    label: "wbo.order-assignment-rule.edit.option.orderType.app-only.orderAtTable",
                    value: OrderTypeInfoData.ORDER_TYPE_APP_AT_TABLE
                },
                {
                    label: "wbo.order-assignment-rule.edit.option.orderType.app-only.orderAhead",
                    value: OrderTypeInfoData.ORDER_TYPE_TAKEAWAY
                },
                {
                    label: "wbo.order-assignment-rule.edit.option.orderType.app-only.orderDelivery",
                    value: OrderTypeInfoData.ORDER_TYPE_DELIVERY
                }
            ]);
        } else {
            this.buildData([
                {
                    label: "wbo.order-assignment-rule.edit.option.orderType.REGULAR",
                    value: OrderTypeInfoData.ORDER_TYPE_REGULAR
                },
                {
                    label: "wbo.order-assignment-rule.edit.option.orderType.AUTO",
                    value: OrderTypeInfoData.ORDER_TYPE_AUTO
                },
                {
                    label: "wbo.order-assignment-rule.edit.option.orderType.TABLE",
                    value: OrderTypeInfoData.ORDER_TYPE_TABLE
                },
                {
                    label: "wbo.order-assignment-rule.edit.option.orderType.TAB",
                    value: OrderTypeInfoData.ORDER_TYPE_TAB
                },
                {
                    label: "wbo.order-assignment-rule.edit.option.orderType.DELIVERY",
                    value: OrderTypeInfoData.ORDER_TYPE_DELIVERY
                },
                {
                    label: "wbo.order-assignment-rule.edit.option.orderType.TAKEAWAY",
                    value: OrderTypeInfoData.ORDER_TYPE_TAKEAWAY
                },
                {
                    label: "wbo.order-assignment-rule.edit.option.orderType.DRIVE_THRU",
                    value: OrderTypeInfoData.ORDER_TYPE_DRIVE_THRU
                },
                {
                    label: "wbo.order-assignment-rule.edit.option.orderType.APP_AT_TABLE",
                    value: OrderTypeInfoData.ORDER_TYPE_APP_AT_TABLE
                },
                {
                    label: "wbo.order-assignment-rule.edit.option.orderType.REFUND",
                    value: OrderTypeInfoData.ORDER_TYPE_REFUND
                },
                {
                    label: "wbo.order-assignment-rule.edit.option.orderType.OUTGOINGS",
                    value: OrderTypeInfoData.ORDER_TYPE_OUTGOINGS
                }
            ]);
        }
    }
}
